module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "chapter-number---IVP",
    attrs: {
      "id": "_idParaDest-5",
      "title": "Dedication"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor052"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor053"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page5",
      "title": "5"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("This book is dedicated to my brothers from other mothers, the men whom I call my lifelong friends and who continue to inspire me to be a better man:")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Mike Aquilina, Joe Dilillo, Joe Groshek, Paul Jarzembowski, George Kalantzis, Graziano Marcheschi, Glenn Murray and Rich Vetrano."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("As iron sharpens iron, so man sharpens his fellow man.")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("Proverbs 27:17")]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor054"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor055"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor056"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor057"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor058"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor059"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor060"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor061"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor062"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor063"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page6",
      "title": "6"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d071e90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/dedication.vue
// module id = 60
// module chunks = 0